// WRW Pricing Table Accordion
document.addEventListener('click', function(event) {
  var btn = event.target.closest('.wrw-pricing-toggle-btn');
  if (!btn) return;
  event.preventDefault();
  event.stopPropagation();
  var expanded = btn.getAttribute('aria-expanded') === 'true';
  btn.setAttribute('aria-expanded', String(!expanded));
  btn.nextElementSibling.classList.toggle('open');
});

// Move pricing toggle above "Choose Color(s) & Quantity" on mobile for stock PDPs
function moveWrwPricingToggle() {
  if (window.innerWidth > 992) return;

  var colorQuantityDiv = document.querySelector('.four_count_side');
  if (!colorQuantityDiv) return;

  // Find the toggle wrapper that is inside the color/tab section
  var wrapper = colorQuantityDiv.querySelector('.wrw-pricing-toggle-wrapper');
  if (!wrapper) return;

  colorQuantityDiv.parentNode.insertBefore(wrapper, colorQuantityDiv);
}

document.addEventListener('DOMContentLoaded', moveWrwPricingToggle);
